(function ($) {
    document.addEventListener('arlojscontrolsloaded', function () {
        var catId = document.getElementById('category-id');
        const platformID = 'forthvalleycollege.arlo.co';

        const catalogue = {
            moduleType: 'CategoryCatalogue',
            targetElement: '#arlo-catalogue',
            template: '#catalogue-template',
            nextRunningEventFilterControlId: 2,
            maxNextRunningEvents: 1,
            categoryFilterDefaultValue: catId.dataset.id,
            loadNextRunningButtonText: 'Find courses',
            includeLoadMoreButton: true,
            loadMoreButtonText: 'Show more categories',
            maxCount: 3,
        };

        const app = new window.ArloWebControls();

        app.start({
            platformID: platformID,
            showDevErrors: false,
            modules: [catalogue],
        });
    });

    /* ----- Callback functions ----- */

    // Events "OnShow" callback
    window.categoryItemsOnShow = function (getRenderCollectionElements, $) {
        const listItems = getRenderCollectionElements();
        const listParent = $(listItems[0]).parent()[0];

        // Set all list items to height of tallest item plus padding
        function setEventTemplateListItemHeight() {
            // Don't run functtion on mobile devices
            if ($(listParent).width() < 767) {
                return;
            }

            $(listParent).find('.arlo-listitem').height('auto');
            let tallestListItemHeight = 0;

            $.each($(listParent).find('.arlo-listitem'), function (index, listItem) {
                // Get height from combining heights of list item elements (because of issue with using listitems own height)
                let height = 0;
                height += $(listItem).height();

                if (height > tallestListItemHeight) {
                    tallestListItemHeight = height;
                }
            });

            $(listParent)
                .find('.arlo-listitem')
                .height(tallestListItemHeight + 110);
        }

        /*setTimeout(function () {
          setEventTemplateListItemHeight();
        }, 0);
    
        $(window).resize(function () {
          setEventTemplateListItemHeight();
        });*/

        setTimeout(function () {
            $.each($(listParent).find('.arlo-listitem'), function (_index, listItem) {
                const location = $(listItem).find('.arlo-hidden-location').text();
                if (location) {
                    if (location == 'Online') {
                        $(listItem)
                            .find('.arlo-location i')
                            .removeClass('fa-map-marker-alt')
                            .addClass('fa-desktop');
                    }

                    $(listItem).find('.arlo-location div').text(location);
                    $(listItem).find('.arlo-location').css('display', 'flex');
                }

                const online = $(listItem).find('.arlo-next-running-online-activity');
                if (online.length > 0) {
                    $(online).find('a').text('Continuous enrolment');
                }
            });
        }, 500);
    };
})(jQuery);